"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNotificationApi = void 0;
exports.createNotificationApi = (axios) => ({
    markNotificationsViewed(notificationIds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.post('/view-notifications', { notificationIds });
        });
    },
    getUnviewedNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get('/notifications')).data;
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90aWZpY2F0aW9uQXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS9ub3RpZmljYXRpb25BcGkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBR2EsUUFBQSxxQkFBcUIsR0FBRyxDQUFDLEtBQW9CLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDeEQsdUJBQXVCLENBQUMsZUFBeUI7O1lBQ3JELE1BQU0sS0FBSyxDQUFDLElBQUksQ0FBQyxxQkFBcUIsRUFBRSxFQUFFLGVBQWUsRUFBRSxDQUFDLENBQUM7UUFDL0QsQ0FBQztLQUFBO0lBRUssd0JBQXdCOztZQUM1QixPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLGdCQUFnQixDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7UUFDbEQsQ0FBQztLQUFBO0NBQ0YsQ0FBQyxDQUFDIn0=